import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Line, Text } from '@antv/g';
import { deepMix, throttle } from '@antv/util';
import { max, min, rollup, sort, bisectCenter, bisector, group } from 'd3-array';
import { subObject } from '../utils/helper';
import { ELEMENT_CLASS_NAME, LABEL_CLASS_NAME } from '../runtime';
import { selectPlotArea, mousePosition } from './utils';
function maybeTransform(options) {
  var _options$transform = options.transform,
    transform = _options$transform === void 0 ? [] : _options$transform;
  var normalizeY = transform.find(function (d) {
    return d.type === 'normalizeY';
  });
  if (normalizeY) return normalizeY;
  var newNormalizeY = {
    type: 'normalizeY'
  };
  transform.push(newNormalizeY);
  options.transform = transform;
  return newNormalizeY;
}
function markValue(markState, markName, channels) {
  var _Array$from$filter$ma = Array.from(markState.entries()).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        mark = _ref2[0];
      return mark.type === markName;
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        mark = _ref4[0];
      var encode = mark.encode;
      var channel = function channel(name) {
        var channel = encode[name];
        return [name, channel ? channel.value : undefined];
      };
      return Object.fromEntries(channels.map(channel));
    }),
    _Array$from$filter$ma2 = _slicedToArray(_Array$from$filter$ma, 1),
    value = _Array$from$filter$ma2[0];
  return value;
}
/**
 * @todo Perf
 */
export function ChartIndex(_a) {
  var _this = this;
  var _a$wait = _a.wait,
    wait = _a$wait === void 0 ? 20 : _a$wait,
    leading = _a.leading,
    _a$trailing = _a.trailing,
    trailing = _a$trailing === void 0 ? false : _a$trailing,
    _a$labelFormatter = _a.labelFormatter,
    labelFormatter = _a$labelFormatter === void 0 ? function (date) {
      return "".concat(date);
    } : _a$labelFormatter,
    style = __rest(_a, ["wait", "leading", "trailing", "labelFormatter"]);
  return function (context) {
    var view = context.view,
      container = context.container,
      update = context.update,
      setState = context.setState;
    var markState = view.markState,
      scale = view.scale,
      coordinate = view.coordinate; // Get line mark value, exit if it is not existed.
    var value = markValue(markState, 'line', ['x', 'y', 'series']);
    if (!value) return;
    // Prepare channel value.
    var Y = value.y,
      X = value.x,
      _value$series = value.series,
      S = _value$series === void 0 ? [] : _value$series;
    var I = Y.map(function (_, i) {
      return i;
    });
    var sortedX = sort(I.map(function (i) {
      return X[i];
    }));
    // Prepare shapes.
    var plotArea = selectPlotArea(container);
    var lines = container.getElementsByClassName(ELEMENT_CLASS_NAME);
    var labels = container.getElementsByClassName(LABEL_CLASS_NAME);
    // The format of label key: `${elementKey}-index`,
    // group labels by elementKey.
    var keyofLabel = function keyofLabel(d) {
      return d.__data__.key.split('-')[0];
    };
    var keyLabels = group(labels, keyofLabel);
    var rule = new Line({
      style: Object.assign({
        x1: 0,
        y1: 0,
        x2: 0,
        y2: plotArea.getAttribute('height'),
        stroke: 'black',
        lineWidth: 1
      }, subObject(style, 'rule'))
    });
    var text = new Text({
      style: Object.assign({
        x: 0,
        y: plotArea.getAttribute('height'),
        text: '',
        fontSize: 10
      }, subObject(style, 'label'))
    });
    rule.append(text);
    plotArea.appendChild(rule);
    // Get the closet date to the rule.
    var dateByFocus = function dateByFocus(coordinate, scaleX, focus) {
      var _coordinate$invert = coordinate.invert(focus),
        _coordinate$invert2 = _slicedToArray(_coordinate$invert, 1),
        normalizedX = _coordinate$invert2[0];
      var date = scaleX.invert(normalizedX);
      return sortedX[bisectCenter(sortedX, date)];
    };
    // Update rule and label content.
    var updateRule = function updateRule(focus, date) {
      rule.setAttribute('x1', focus[0]);
      rule.setAttribute('x2', focus[0]);
      text.setAttribute('text', labelFormatter(date));
    };
    // Store the new inner state alter rerender the view.
    var newView;
    // Rerender the view to update basis for each line.
    var updateBasisByRerender = function updateBasisByRerender(focus) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var scaleX, date, newState;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Find the closetDate to the rule.
              scaleX = scale.x;
              date = dateByFocus(coordinate, scaleX, focus);
              updateRule(focus, date);
              setState('chartIndex', function (options) {
                // Clone options and get line mark.
                var clonedOptions = deepMix({}, options);
                var lineMark = clonedOptions.marks.find(function (d) {
                  return d.type === 'line';
                });
                // Update domain of y scale for the line mark.
                var r = function r(I) {
                  return max(I, function (i) {
                    return +Y[i];
                  }) / min(I, function (i) {
                    return +Y[i];
                  });
                };
                var k = max(rollup(I, r, function (i) {
                  return S[i];
                }).values());
                var domainY = [1 / k, k];
                deepMix(lineMark, {
                  scale: {
                    y: {
                      domain: domainY
                    }
                  }
                });
                // Update normalize options.
                var normalizeY = maybeTransform(lineMark);
                normalizeY.groupBy = 'color';
                normalizeY.basis = function (I, Y) {
                  var i = I[bisector(function (i) {
                    return X[+i];
                  }).center(I, date)];
                  return Y[i];
                };
                // Disable animation.
                var _iterator = _createForOfIteratorHelper(clonedOptions.marks),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var mark = _step.value;
                    mark.animate = false;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                return clonedOptions;
              });
              _context.next = 6;
              return update();
            case 6:
              newState = _context.sent;
              newView = newState.view;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    // Only apply translate to update basis for each line.
    // If performance is ok, there is no need to use this
    // strategy to update basis.
    var updateBasisByTranslate = function updateBasisByTranslate(focus) {
      // Find the closetDate to the rule.
      var _newView = newView,
        scale = _newView.scale,
        coordinate = _newView.coordinate;
      var scaleX = scale.x,
        scaleY = scale.y;
      var date = dateByFocus(coordinate, scaleX, focus);
      updateRule(focus, date);
      // Translate mark and label for better performance.
      var _iterator2 = _createForOfIteratorHelper(lines),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var line = _step2.value;
          // Compute transform in y direction.
          var _line$__data__ = line.__data__,
            SI = _line$__data__.seriesIndex,
            key = _line$__data__.key;
          var i = SI[bisector(function (i) {
            return X[+i];
          }).center(SI, date)];
          var p0 = [0, scaleY.map(1)]; // basis point
          var p1 = [0, scaleY.map(Y[i] / Y[SI[0]])];
          var _coordinate$map = coordinate.map(p0),
            _coordinate$map2 = _slicedToArray(_coordinate$map, 2),
            y0 = _coordinate$map2[1];
          var _coordinate$map3 = coordinate.map(p1),
            _coordinate$map4 = _slicedToArray(_coordinate$map3, 2),
            y1 = _coordinate$map4[1];
          var dy = y0 - y1;
          line.setAttribute('transform', "translate(0, ".concat(dy, ")"));
          // Update line and related label.
          var _labels = keyLabels.get(key) || [];
          var _iterator3 = _createForOfIteratorHelper(_labels),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var label = _step3.value;
              // @todo Replace with style.transform.
              // It now has unexpected behavior.
              label.setAttribute('dy', dy);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
    var updateBasis = throttle(function (event) {
      var focus = mousePosition(plotArea, event);
      if (!focus) return;
      updateBasisByTranslate(focus);
    }, wait, {
      leading: leading,
      trailing: trailing
    });
    updateBasisByRerender([0, 0]);
    plotArea.addEventListener('pointerenter', updateBasis);
    plotArea.addEventListener('pointermove', updateBasis);
    plotArea.addEventListener('pointerleave', updateBasis);
    return function () {
      rule.remove();
      plotArea.removeEventListener('pointerenter', updateBasis);
      plotArea.removeEventListener('pointermove', updateBasis);
      plotArea.removeEventListener('pointerleave', updateBasis);
    };
  };
}